import { useCallback, useState } from 'react';
export const DIALOG_ANIMATION_DURATION = 350;

export interface UseDialogWithPayloadOutput<T> {
  show(payload: T): void;
  close(): void;
  visible: boolean;
  payload?: T;
}
export function useDialogWithPayload<T>(initialPayload?: T): UseDialogWithPayloadOutput<T> {
  const [payload, setPayload] = useState<T | undefined>(initialPayload);
  const [visible, setVisible] = useState<boolean>(!!initialPayload);

  const show = useCallback((payload: T) => {
    setPayload(payload);
    setVisible(true);
  }, []);

  const close = useCallback(() => {
    setVisible(false);
    setTimeout(() => {
      setPayload(undefined);
    }, DIALOG_ANIMATION_DURATION);
  }, []);

  return {
    show,
    close,
    visible,
    payload
  };
}
